module.exports = {
  InteractivePlugin: {
    PluginName: "Etkileşim Eklentisi",
    display_name: "Etkileşim",
    flow_items: "Akış Öğeleri",
  },
};
